<div class="container-fluid">
    <div class="d-flex justify-content-center">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <mat-spinner></mat-spinner>
    </div>
</div>


<!--<button (click)="OnLogout()">OnLogout</button>-->